import { render, staticRenderFns } from "./ot-traffic-lights.vue?vue&type=template&id=1f559698&scoped=true&"
import script from "./ot-traffic-lights.vue?vue&type=script&lang=ts&"
export * from "./ot-traffic-lights.vue?vue&type=script&lang=ts&"
import style0 from "./ot-traffic-lights.vue?vue&type=style&index=0&id=1f559698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f559698",
  null
  
)

export default component.exports